import React from 'react';
import { opsGetConversationsList } from 'api/operation';
import { EMessageSenderType, TConversation } from 'types/inbox';
import { getUserId } from 'utils/localstore';

const useOpsMessageConversations = (
    size?: number,
): [TConversation[] | undefined, boolean, (size?: number, clientId?: string) => void] => {
    const loading = React.useRef(false);
    const [items, setItems] = React.useState<TConversation[]>();
    const fetchData = async (_size?: number) => {
        try {
            loading.current = true;
            const result = await opsGetConversationsList(1, _size || size || 1000, true);
            if (!result.error) {
                const data: TConversation[] = result?.data?.data?.records || [];
                data.forEach((item) => {
                    item.isOpsByMe = item.members.some((member) => {
                        return `${member.userId}` === `${getUserId()}` && member.userType === EMessageSenderType.OPS;
                    });
                });
                setItems(data);
            }
            loading.current = false;
        } catch (e) {
            console.error(e);
            loading.current = false;
        }
    };
    React.useEffect(() => {
        if (!loading.current) {
            fetchData(size);
        }
    }, [size]);

    return [items, loading.current, fetchData];
};

export default useOpsMessageConversations;
